{
  "alert": "Opozorilo",
  "dismiss": "Opusti"
}